import * as React from 'react';
import formStyle from '../style/WForm.less';
import { WActionButton } from '../../elements/WActionButton';
import DialogWrapper from '../../dialog/dialog_wrapper';
import { WFormsTableWrapper } from '../../table/WFormsTableWrapper';
import { lazyInject } from '../../../services/inversify';
import { StructureService } from '../../../services/structure_service';

interface WFormFieldSelectDialogProps extends React.ClassAttributes<any> {
    module: string;
    label: JSX.Element;
    name: string;
    value: string;
    entity: string;
    fields: Array<string>;
    required?: boolean;
    readonly?: boolean;
    bundle_value?: string;
    bundle_text?: string;
    bundle_assign?: Array<any>;
    options: Array<any>;
    validationMsg?: string;
    layout?: string;
    disabled?: boolean;
    onValueChange(name: string, value: any): void;
    filterOptions?(options: Array<any>, key: string, data: any): Array<any>;  // Filter-Funktion für Options
    getFormData?(): any;                                                // Funktion zum holen der Formdaten (wg. Filter)
}
interface WFormFieldSelectDialogState {
    showDialog: boolean;
}
export class WFormFieldSelectDialog extends React.Component<WFormFieldSelectDialogProps, WFormFieldSelectDialogState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false
        };
    }
    @lazyInject(StructureService) private structureService: StructureService;

    componentDidMount() {
        const fieldValue: string = this.props.bundle_value ? this.props.bundle_value : 'tid';

        if (!this.props.value && this.props.options && this.props.options.length > 0) {
            this.props.onValueChange(this.props.name,  this.props.options[0][fieldValue]);
        }
    }
    render() {
        const disabled = this.props.readonly || this.props.disabled ? true : false;
        return (
            <div className={formStyle.fieldBox}>
                    {this.props.label}
                    {!disabled &&
                    <div className={formStyle.input}>
                        <div className={formStyle.rowContainer}>
                            <div>{this.renderSelection()}</div>
                            <WActionButton
                                label='Bearbeiten'
                                action='edit'
                                styleProps={{ width: '16px', height: '16px' }}
                                onAction={(action: string) => this.setState({ showDialog: true })}
                            />

                        </div>
                    </div>
                    }
                    {this.state.showDialog &&
                        <div>
                            <DialogWrapper
                                onAfterClose = {() => this.setState({ showDialog: false })}
                            >
                                {this.renderSelectionTable()}
                            </DialogWrapper>
                        </div>
                    }
            </div>
        );
    }
    renderSelectionTable(): JSX.Element {
        const struct = this.structureService.getStructureByKey(this.props.module, this.props.entity);
        // console.log(struct.ATTS , this.props.fields);
        const hiddenColumns = struct.ATTS.filter((a: any) => this.props.fields.indexOf(a.KEY) === -1)
                                         .map((a: any) => a.KEY);
         const table = <WFormsTableWrapper
                    module = {this.props.module}
                    entity = {this.props.entity}
                    data = {this.props.options}
                    customActions = {[this.getCustomAction()]}
                    actions = {[]}
                    tablePageSize = {10}
                    hiddenColumns = {hiddenColumns}
                />;
        return (<div>
               {table}
        </div>);
    }
    getCustomAction() {
        const action = {
            label: 'Wählen',
            key: 'forward',
            func: ((row: any) => {
                const fieldValue: string = this.props.bundle_value ? this.props.bundle_value : 'tid';
                const value = row[fieldValue];
                this.props.onValueChange(this.props.name, value);
                this.setState({ showDialog: false });
                return ;
            }),
            info: 'Auswählen / Übernehmen'
        };
        return action;
    }
    renderSelection() {
        const fieldValue: string = this.props.bundle_value ? this.props.bundle_value : 'tid';
        let parts = '';
        const itemFound = this.props.options.find((item: any) => item[fieldValue] === this.props.value);
        if (itemFound) {
            this.props.fields.forEach((f) => {parts += itemFound[f] + ' '; });
        }
        return (<span>{parts.trim()}</span>);
    }
}
